
export const montessori = {
  title: "Educação Montessori",
  bookVisit: "Agende uma visita",
  intro: {
    description: "A nossa abordagem inspira-se na metodologia Montessori, combinada com uma visão educativa própria que integra natureza, trilinguismo e acompanhamento respeitoso. Na Gándara International School, acreditamos na filosofia Montessori como base do nosso projeto educativo. Esta abordagem pedagógica, desenvolvida pela Dra. Maria Montessori há mais de um século, continua revolucionária na sua compreensão do desenvolvimento infantil e no seu respeito por cada criança como indivíduo único."
  },
  principles: {
    environment: {
      title: "Ambiente Preparado",
      description: "Criamos espaços cuidadosamente projetados que convidam à exploração e à aprendizagem autodirigida, com materiais adaptados a cada estágio de desenvolvimento."
    },
    accompaniment: {
      title: "Acompanhamento Respeitoso",
      description: "Os nossos guias Montessori observam e acompanham o processo natural de aprendizagem de cada criança, oferecendo apoio quando necessário enquanto respeitamos a sua autonomia."
    },
    learning: {
      title: "Aprendizagem Ativa",
      description: "As crianças constroem seu conhecimento através da manipulação, experimentação e descoberta, desenvolvendo uma compreensão profunda dos conceitos."
    },
    nature: {
      title: "Conexão com a Natureza",
      description: "Incentivamos o contato direto com o ambiente natural como fonte de aprendizagem, bem-estar e desenvolvimento da consciência ecológica."
    },
    autonomy: {
      title: "Desenvolvimento da Autonomia",
      description: "Cultivamos a independência e a capacidade de tomar decisões, permitindo às crianças serem protagonistas da sua própria aprendizagem."
    },
    coexistence: {
      title: "Comunidade e Convivência",
      description: "Promovemos relações baseadas no respeito mútuo, colaboração e resolução pacífica de conflitos dentro da nossa comunidade de aprendizagem."
    }
  },
  space: {
    title: "Nosso Espaço",
    description1: "Gándara está localizada em um ambiente privilegiado que combina natureza e proximidade ao centro urbano de Vigo.",
    description2: "Nossas instalações são projetadas especificamente para facilitar a aprendizagem Montessori, com espaços luminosos, ordenados e adaptados às necessidades das crianças.",
    description3: "Cada sala de aula é um ambiente preparado onde os materiais estão organizados de maneira lógica e acessível, convidando à atividade autônoma e à descoberta.",
    property: "Propriedade de mais de 5.000 m² com amplas áreas verdes, horta escolar e áreas de jogo ao ar livre",
    facilities: "Espaços interiores acolhedores com materiais Montessori de alta qualidade",
    location: "Localização estratégica: a 10 minutos do centro de Vigo e com fácil acesso pela AP-9"
  },
  classrooms: {
    title: "Salas Montessori",
    description: "Os nossos ambientes preparados são concebidos para promover a autonomia, a exploração e a aprendizagem ativa em cada etapa do desenvolvimento."
  },
  infantil: {
    title: "Educação Infantil (3-6 anos)",
    description: "Na etapa infantil, as crianças trabalham num ambiente preparado com materiais Montessori que convidam à exploração sensorial, ao desenvolvimento da linguagem e às primeiras noções matemáticas.",
    classroom: "A sala de infantil é um espaço luminoso e organizado onde cada material tem o seu lugar. As crianças escolhem livremente as suas atividades e trabalham ao seu ritmo, acompanhadas por guias formados em metodologia Montessori."
  },
  primary: {
    title: "Ensino Primário (6-12 anos)",
    description: "A etapa primária divide-se em dois ciclos: Oficina 1 (6-9 anos) e Oficina 2 (9-12 anos). As crianças trabalham em projetos interdisciplinares que ligam áreas de conhecimento e promovem a investigação.",
    classroom: "No primário, a aprendizagem estende-se para além da sala de aula. Projetos de investigação, saídas ao meio natural e trabalho cooperativo formam a base da nossa proposta educativa."
  },
  nature: {
    title: "Natureza e Aprendizagem Ativa",
    description: "Na Gándara, a natureza não é apenas um cenário: é uma ferramenta pedagógica. Os nossos mais de 5.000 m² de propriedade oferecem horta, jardim e espaços verdes onde as crianças aprendem ciências naturais de forma vivencial, desenvolvem a motricidade e conectam-se com os ciclos da vida."
  }
};
